import { useState, useEffect, useContext } from "react";

import { Button } from "@mui/material";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import useEnsureAssessmentDetails from '../../Hooks/useEnsureAssessmentDetails';
import AssessmentProgressContext from "../../Store/AssessmentProgressContext";
import EastIcon from '@mui/icons-material/East'
import WestIcon from '@mui/icons-material/West'
import img1 from "../../Assets/Images/COLLABORATIVE.png";
import img2 from "../../Assets/Images/COLLABORATIVE.png";
import img3 from "../../Assets/Images/COLLABORATIVE.png";
import img4 from "../../Assets/Images/COLLABORATIVE.png";
import img5 from "../../Assets/Images/COLLABORATIVE.png";
import GreyTick from '../../Assets/Images/grey-tick.svg'
import GreenTick from '../../Assets/Images/green-tick.svg'
import sampleQue from '../../Assets/Images/sampleQue.png'
import AssessmentQuestionContext from "../../Store/AssessmentQuestionContext";

const mostAnswers = [
  { id: 1, answer: ["I use logic and clear thinking to solve problems."], img: GreyTick },
  { id: 2, answer: ["I trust my instincts to make decisions."], img: GreyTick },
  { id: 3, answer: ["I focus on building connections and inspiring others."], img: GreenTick },
  { id: 4, answer: ["I rely on my strength and determination to get things done."], img: GreyTick },
];

const leastAnswers = [
  { id: 1, answer: ["I use logic and clear thinking to solve problems."], img: GreyTick },
  { id: 2, answer: ["I trust my instincts to make decisions."], img: GreenTick },
  { id: 4, answer: ["I rely on my strength and determination to get things done."], img: GreyTick },
];

const selectAnswers = ["Never", "Rarely", "Occasionally", "Sometimes", "Frequently", "Usually", "Always"]

const PreAssessment = () => {

  const assessProgressCtx = useContext(AssessmentProgressContext);

  const { windowWidth } = useWindowDimensions();
  const { id } = useParams();
  const assessCtx = useContext(AssessmentQuestionContext)

  const [searchParams] = useSearchParams();
  let navigate = useNavigate();
  const location = useLocation();
  const [pathname, setPathname] = useState();
  const params = useParams()
  const [clientId, setClientId] = useState(null)
  const [leader, setLeader] = useState(null);
  const [member, setMember] = useState(null);
  const [respondentName, setRespondentName] = useState(null);
  const [hasLeader, setHasLeader] = useState(false)
  const [mobileStep, setMobileStep] = useState(0);
  const [transitionDirection, setTransitionDirection] = useState("right");
  useEnsureAssessmentDetails(id, searchParams);

  useEffect(() => {
    const localStorageKey = `searchParams-${id}`;
    const storedData = JSON.parse(localStorage.getItem(localStorageKey)) || {};
  
    const paramsLeader = searchParams.get("leader");
    const paramsMember = searchParams.get("member");
    const paramsName = searchParams.get("respondentName");
    const paramsClientId = searchParams.get("clientId");
  
    const updatedData = {
      ...storedData,
      leader: storedData.leader || paramsLeader || null,
      member: storedData.member || paramsMember || null,
      respondentName: storedData.respondentName || paramsName || null,
      clientId: storedData.clientId || paramsClientId || null,
    };
  
    if (
      storedData.leader !== updatedData.leader ||
      storedData.member !== updatedData.member ||
      storedData.respondentName !== updatedData.respondentName ||
      storedData.clientId !== updatedData.clientId
    ) {
      localStorage.setItem(localStorageKey, JSON.stringify(updatedData));
    }
  
    setLeader(updatedData.leader);
    setMember(updatedData.member);
    setRespondentName(updatedData.respondentName);
    setHasLeader(!!updatedData.leader);
    setClientId(updatedData.clientId)
  }, [id, searchParams]);

    useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(`searchParams-${id}`)) || {};
    assessCtx?.setLeaderName(storedData.leader)
  }, [])

  console.log('id', id)

  useEffect(() => {
  if (location.state?.fromExplainer) {
    setTransitionDirection("right"); 
    setMobileStep(0); 
  } else if (location.state?.fromBack) {
    setTransitionDirection("left"); 
    setMobileStep(1); 
  } else {
    setTransitionDirection("right");
    setMobileStep(0);
  }

  window.history.replaceState({}, document.title);
}, [location]);


  useEffect(() => {
    // document.body.style.backgroundColor = "#343333";
    // assessProgressCtx.updateMainSectionsStatus(assessProgressCtx?.mainSections?.map(sec => ({ ...sec, status: "unfinished" })));
  }, []);

  useEffect(() => {
    console.log('location', location)
    setPathname(location.pathname)
  }, [location]);

  const assessmentLink = () => {
    // if(!searchParams) return "/assessment";
    // else return "/assessment?" + searchParams;
    const pageId = 743; // TODO: update this number according to page ID for questions
    const navigationParams = new URLSearchParams(searchParams);
    ["userName", "orgId", "clientId", "leader", "member", "client"].forEach((key) => navigationParams.delete(key));
    navigate("/assessment/" + id + "/" + pageId + "?" + navigationParams.toString(), { replace: true });
  }

  const handleNext = () => {
    const navigationParams = new URLSearchParams(searchParams);
    ["userName", "orgId", "clientId", "leader", "member", "client"].forEach((key) => navigationParams.delete(key));
    navigate(`/walkthrough/${params.id}/?${navigationParams.toString()}`, { replace: true, state: { fromBack: true, fromBeforeYouBegin: true } });
  }

  // In your before-you-begin page:
  const handleBack = () => {
    const navigationParams = new URLSearchParams(searchParams);
    ["userName", "orgId", "clientId", "leader", "member", "client"].forEach((key) => navigationParams.delete(key));
    navigate(`/explainer/${params.id}/?${navigationParams.toString()}`, {
      
      replace: true, 
      state: { currentIndex: 3 }  // 3 represents the 4th tab
   ,
      state: { showAllCards: true } // This will tell the Explainer component to show all cards
    });
  }

  return (
    <div className="container pre-assessment" >
      <div className="heading">
        <h1>Before You Begin</h1>
        {!(windowWidth < 650 && mobileStep === 1) && (
          <p className="pre-assessment-subheader">This assessment will include two types of questions. Here's what to expect:</p>
        )}
      </div>
      {/* <div className="explanation">
      <div className="marker red"></div><p>The benchmark is not in position to activate the Great Commission or multiply Kingdom impact. It is potentially broken or barely functioning to these standards, and demands attention.</p>
      </div>
      <div className="explanation">
      <div className="marker yellow"></div><p>The benchmark affects Great Commission activation and multiplies Kingdom impact but has room for improvement. It is not at its top level of effectiveness, and needs further action to become optimal.</p>
      </div>
      <div className="explanation">
      <div className="marker green"></div><p>The benchmark activates the Great Commission and multiplies Kingdom impact. It is effective and healthy, but might need slight improvement. Ensure it has the resources and attention it needs.</p>
      </div> */}

      {/* <div className="img-text-row">
        {data.map((item, idx) => (
          <ImageTextContainer key={idx} {...item} />
        ))}
      </div> */}
      <div className="info-containers">
      {windowWidth < 712 ? (
    <>
      {mobileStep === 0 && (
        <div className={`left-container ${transitionDirection === "left" ? "slide-in-left" : "slide-in-right"}`}>
          <div className="container-heading">
            <h3>1. Most and Least Statements</h3>
          </div>
          <div className="asmt-sample-container">
            <div className="sample-one">
              <div className="sample-que">
                <p className="question">Select the statement that <span className="most">MOST </span> accurately represents {hasLeader ? "the participant" : "you"}.</p>
              </div>
              <div className="sample-ans">
                {mostAnswers?.map((ans, i) => (
                  <>
                    <div className="answers" key={ans.id} style={{ backgroundColor: ans.id === 3 ? "#00577D" : "#FFFFFFBF", color: ans.id === 3 ? "#FFFFFF" : "#5F5F5F", }} >
                      <img src={ans.img} alt="" />
                      <p>{ans.answer}</p>
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="sample-two">
              <div className="sample-que">
                <p className="question">Great! Now select the statement that <span className="least">LEAST </span> accurately represents {hasLeader ? "the participant" : "you"}.</p>
              </div>
              <div className="sample-ans">
                {leastAnswers?.map((ans, i) => (
                  <>
                    <div className="answers" key={ans.id} style={{ backgroundColor: ans.id === 2 ? "#B6111F" : "#FFFFFFBF", color: ans.id === 2 ? "#FFFFFF" : "#5F5F5F", }}>
                      <img src={ans.img} alt="" />
                      <p>{ans.answer}</p>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
          <div className="description">
            <p className="top-line">On every page, please either select:</p>
            <ul>
              <li>The statement that <span className="most">MOST </span> accurately represents {hasLeader ? "the participant" : "you"}</li>
              <li>Or the statement that <span className="least">LEAST</span> accurately represents {hasLeader ? "the participant" : "you"}</li>
            </ul>
            <p className="bottom-line">There are no right or wrong answers—just be honest!</p>
          </div>
        </div>
        )}
      {mobileStep === 1 && (
        <div className={`right-container ${transitionDirection === "left" ? "slide-in-left" : "slide-in-right"}`}>
          <div className="container-heading">
            <h3>2. Frequency Rating</h3>
          </div>
          {/* <div className="asmt-sample-container">
            <p className="question">I embrace challenges</p>
            <div className="select-answers">
              {selectAnswers.map((ans, i) => (
                <p key={i}>{ans}</p>
              ))}
            </div>
          </div> */}
          <img src={sampleQue} alt="questson" />
          <div className="description">
            <p className="description-one">You’ll be asked to rate statements using a 7-point range from <strong>Never</strong> to <strong>Always</strong>.</p>
            <p className="description-two">Please choose the response that best represents {hasLeader ? "the participant" : "you"} most of the time.</p>
          </div>
        </div>
        )}
        </>
        ) : (
        <>
        <div className="left-container">
          <div className="container-heading">
            <h3>1. Most and Least Statements</h3>
          </div>
          <div className="asmt-sample-container">
            <div className="sample-one">
              <div className="sample-que">
                <p className="question">Select the statement that <span className="most">MOST </span> accurately represents {hasLeader ? "the participant" : "you"}.</p>
              </div>
              <div className="sample-ans">
                {mostAnswers?.map((ans, i) => (
                  <>
                    <div className="answers" key={ans.id} style={{ backgroundColor: ans.id === 3 ? "#00577D" : "#FFFFFFBF", color: ans.id === 3 ? "#FFFFFF" : "#5F5F5F", }} >
                      <img src={ans.img} alt="" />
                      <p>{ans.answer}</p>
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="sample-two">
              <div className="sample-que">
                <p className="question">Great! Now select the statement that <span className="least">LEAST </span> accurately represents {hasLeader ? "the participant" : "you"}.</p>
              </div>
              <div className="sample-ans">
                {leastAnswers?.map((ans, i) => (
                  <>
                    <div className="answers" key={ans.id} style={{ backgroundColor: ans.id === 2 ? "#B6111F" : "#FFFFFFBF", color: ans.id === 2 ? "#FFFFFF" : "#5F5F5F", }}>
                      <img src={ans.img} alt="" />
                      <p>{ans.answer}</p>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
          <div className="description">
            <p className="top-line">On every page, please either select:</p>
            <ul>
              <li>The statement that <span className="most">MOST </span> accurately represents {hasLeader ? "the participant" : "you"}</li>
              <li>Or the statement that <span className="least">LEAST</span> accurately represents {hasLeader ? "the participant" : "you"}</li>
            </ul>
            <p className="bottom-line">There are no right or wrong answers—just be honest!</p>
          </div>
        </div>
        <div className="right-container">
          <div className="container-heading">
            <h3>2. Frequency Rating</h3>
          </div>
          <div className="asmt-sample-container">
            <p className="question">I embrace challenges</p>
            <div className="select-answers">
              {selectAnswers.map((ans, i) => (
                <p key={i}>{ans}</p>
              ))}
            </div>
          </div>
          <div className="description">
            <p className="description-one">You’ll be asked to rate statements using a 7-point range from <strong>Never</strong> to <strong>Always</strong>.</p>
            <p className="description-two">Please choose the response that best represents {hasLeader ? "the participant" : "you"} most of the time.</p>
          </div>
        </div>
        </>
        )}
      </div>

      {windowWidth < 712 && (
        <div className="progress-indicator">
          {[0, 1].map((step) => (
            <span
              key={step}
              className={`dot ${step === mobileStep ? "active" : ""}`}
            ></span>
          ))}
        </div>
      )}




      {/* <p>Answer ten questions about each aspect to check if your ministry is drifting today.</p> */}
      {/* <Link to={assessmentLink()} className="cta-link"> */}
      {/* <Button className="cta" onClick={() => assessmentLink()}>Take The Indicator</Button> */}
      <div className="buttons">
        {windowWidth < 712 ? (
    <>
      {mobileStep === 1 && (
        <button className="back-btn" onClick={() => {
          setTransitionDirection("left");
          setMobileStep(0);
        }}>
          <WestIcon /> Back
        </button>
      )}
      {mobileStep === 0 ? (
        <>
        <button
          className="back-btn"
          onClick={handleBack}
        >
          < WestIcon /> Back
        </button>

        <button className="next-btn" onClick={() => {
          setTransitionDirection("right");
          setMobileStep(1);
        }}>
          Next < EastIcon />
        </button>
        </>
      ) : (
        <button className="next-btn" style={{ width: '163px' }} onClick={handleNext}>
          Continue < EastIcon />
        </button>
      )}
    </>
  ) : (
      <>
        <button
          className="back-btn"
          onClick={handleBack}
        // disabled={currentIndex === 0}
        >
          < WestIcon /> Back
        </button>
        <button
          className="next-btn"
          onClick={handleNext}
          style={{ width: '155px' }}
        // disabled={currentIndex === categories.length - 1}
        >
          Continue < EastIcon />
        </button>
        </>
      )}
      </div>
      {/* </Link> */}

    </div>
  )
}


export default PreAssessment;



const ImageTextContainer = ({ name, text, img }) => {

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="img-text-wrapper"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered ? (
        <>
          <div className="text">
            {text?.map((txt, idx) => {
              return <p key={idx}>{txt}</p>
            })}
          </div>
          <p className="img-label">{name}</p>
        </>
      ) : (
        <>
          <div className="img">
            <img src={img} alt={name} />
          </div>
          <p className="img-label">{name}</p>
        </>
      )}
    </div>
  );
};
